/**
 * Created by nijin on 9/2/17.
 */
import { Injectable } from '@angular/core';
import {HttpService} from "../auth/http.client.service";
import {environment} from "../../environments/environment";
import {Observable} from "rxjs";
import {Response} from "@angular/http";
import {AuthService} from "../auth/auth.service";
import {EntityService} from "../core/entity.service";

@Injectable()
export class AccountService {
  private accountURI = `${environment.serviceBase}/accounts/:accountId`;
  private passwordURI = `${environment.serviceBase}/password/change`;

  constructor(private http: HttpService,
              private authService: AuthService,
              private entityService: EntityService) { }

  getAllUsers(): Observable<any>{
    const uri = this.http.buildPath(this.accountURI,{accountId:this.authService.getCurrentAccount().id});
    return this.http.get(`${this.accountURI}/users`)
      .map(this.extractData)
      .catch(this.handleError)
  }

  updateProfile(data): Observable<any>{
    const uri = this.http.buildPath(this.accountURI,{accountId:this.authService.getCurrentAccount().id});
    let payload = data;
    data.role = this.authService.getCurrentAccount().userRole;
    payload.name = data.name;
    return this.http.put(`${uri}/users/${this.authService.getUserProfile().id}`, payload)
      .map((response)=>{return response.json()})
      .catch(this.handleError);
  }

  updatePassword(data):Observable <any>{
    data.userId = this.authService.getUserProfile() ? this.authService.getUserProfile()['id'] : null;
    return this.http.put(this.passwordURI,data)
      .map((response)=>{return response.json()})
      .catch(this.handleError);
  }


  private handleError (error: Response | any) {
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      errMsg = body.status.message
    } else {
      errMsg = error.message ? error.message : error.toString();
    }

    return Observable.throw(errMsg);
  }
  private extractData(res: Response){
    let body = res.json();
    return body.data || { };
  }

}



// WEBPACK FOOTER //
// ./src/app/accounts/account.service.ts